import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import aboutImg from '../../images/profile1.jpg'

const Expertise = ["HTML", "CSS", "Bootstrap", "JavaScript", "ES6", "React.js"]
const Comfortable = ["Node.js", "Express.js", "MongoDB", "C", "C++", "Python"]
const Familiar = ["Redux.js", "TypeScript", "SASS"]
const Tools = ["VS Code", "Git", "Firebase", "Netlify", "Heroku"]

const AboutDetail = () => {
    return (
        <div className="container">
            <div className="row">
                <div className="col-sm- 12 col-md-6 p-5">
                    <div className="col-md-8 mt-5">
                        <img className="img-fluid" src={aboutImg} alt="Habibullah Asif" />
                    </div>
                    <h2 className="mt-3 mb-3">Habibullah Md.Asif</h2>
                    <p className="lead">
                        I am a self-taught web developer. I am passionate about all things in JavaScript. I primarily focus on writing clean, elegant, and efficient code. I am proficient at HTML, CSS, Bootstrap, JavaScript, and React.js
                    </p>
                    <div className="d-flex align-items-center justify-content-center fs-1 gap-3">
                        <a target="_blank" href="https://www.linkedin.com/in/habibullah-asif">
                            <FontAwesomeIcon icon={faLinkedin} />
                        </a>
                        <a target="_blank" href="https://github.com/asif10h" >
                            <FontAwesomeIcon icon={faGithub} />
                        </a>
                        <a target="_blank" href="https://facebook.com/asif10h">
                            <FontAwesomeIcon icon={faFacebook} />
                        </a>
                    </div>
                </div>
                <div className="col-sm-12 col-md-6 mt-5 p-5">
                    <h2>Skills</h2>
                    <div className="mt-3">
                        <h5>Expertise</h5>
                        {
                            Expertise.map(
                                item => (
                                    <li className="list-inline-item bg-dark text-white rounded ps-2 pe-2 m-2">{item}</li>
                                )
                            )
                        }
                    </div>
                    <div className="mt-3">
                        <h5>Comfortable</h5>
                        {
                            Comfortable.map(
                                item => (
                                    <li className="list-inline-item bg-dark text-white rounded ps-2 pe-2 m-2">{item}</li>
                                )
                            )
                        }
                    </div>
                    <div className="mt-3">
                        <h5>Familiar</h5>
                        {
                            Familiar.map(
                                item => (
                                    <li className="list-inline-item bg-dark text-white rounded ps-2 pe-2 m-2">{item}</li>
                                )
                            )
                        }
                    </div>
                    <div className="mt-3">
                        <h5>Tools</h5>
                        {
                            Tools.map(
                                item => (
                                    <li className="list-inline-item bg-dark text-white rounded ps-2 pe-2 m-2">{item}</li>
                                )
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutDetail;